import React from 'react';
import { DrawerProps as AntDrawerProps } from 'antd';
import { StyledDrawer } from './DrawerStyles';

export type TDrawerProps = AntDrawerProps;

const Drawer: React.FC<TDrawerProps> = (props) => {
  return <StyledDrawer {...props} />;
};

export default Drawer;
